import { ActionContext, ActionTree, MutationTree } from "vuex";
import { IRacineState, ITrainProgressionState } from "../models";

export enum Etapes {
  "Accueil",
  "Clientele",
  "Periode",
  "Emplacement",
  "Casier",
  "Revision",
  "Paiement",
}
export type NomEtapes = keyof typeof Etapes;

export const stateDeBase = (): ITrainProgressionState => {
  return {
    precedentActive: false,
    suivantActive: false,
    suivantCache: false,
    etapeCourante: Etapes[0].toString() as NomEtapes,
    surAnnuler: false,
  };
};

export const state: ITrainProgressionState = stateDeBase();

interface IMutations {
  choisirEtape: (state: ITrainProgressionState, etape: Etapes) => void;
  activerPrecedent: (state: ITrainProgressionState) => void;
  desactiverPrecedent: (state: ITrainProgressionState) => void;
  activerSuivant: (state: ITrainProgressionState) => void;
  desactiverSuivant: (state: ITrainProgressionState) => void;
  cacherSuivant: (state: ITrainProgressionState) => void;
  afficherSuivant: (state: ITrainProgressionState) => void;
  effacerStateTrainProgression: (state: ITrainProgressionState) => void;
  lancerAnnulation: (state: ITrainProgressionState) => void;
  cacherAnnulation: (state: ITrainProgressionState) => void;
}

export const mutations: IMutations & MutationTree<ITrainProgressionState> = {
  choisirEtape: (state: ITrainProgressionState, etape: Etapes) => {
    state.etapeCourante = etape.toString() as NomEtapes;
  },
  activerPrecedent: (state: ITrainProgressionState) => {
    state.precedentActive = true;
  },
  desactiverPrecedent: (state: ITrainProgressionState) => {
    state.precedentActive = false;
  },
  activerSuivant: (state: ITrainProgressionState) => {
    state.suivantActive = true;
  },
  desactiverSuivant: (state: ITrainProgressionState) => {
    state.suivantActive = false;
  },
  cacherSuivant: (state: ITrainProgressionState) => {
    state.suivantCache = true;
  },
  afficherSuivant: (state: ITrainProgressionState) => {
    state.suivantCache = false;
  },
  effacerStateTrainProgression: (state: ITrainProgressionState) => {
    Object.assign(state, stateDeBase());
  },
  lancerAnnulation: (state: ITrainProgressionState) => {
    state.surAnnuler = true;
  },
  cacherAnnulation: (state: ITrainProgressionState) => {
    state.surAnnuler = false;
  },
};

interface IActions {
  etapeSuivante: (
    context: ActionContext<ITrainProgressionState, IRacineState>
  ) => string;
  etapePrecedente: (
    context: ActionContext<ITrainProgressionState, IRacineState>
  ) => string;
  etapeDepart: (
    context: ActionContext<ITrainProgressionState, IRacineState>
  ) => string;
  choisirEtape: (
    context: ActionContext<ITrainProgressionState, IRacineState>,
    etape: Etapes
  ) => string;
  debuterLocation: (
    context: ActionContext<ITrainProgressionState, IRacineState>
  ) => string;
}

export const actions: IActions &
  ActionTree<ITrainProgressionState, IRacineState> = {
  etapeSuivante(context) {
    let index = Etapes[context.state.etapeCourante];
    index++;

    context.commit(mutations.choisirEtape.name, Etapes[index]);
    context.commit(mutations.desactiverSuivant.name);

    return context.state.etapeCourante.toString();
  },
  etapePrecedente(context) {
    let index = Etapes[context.state.etapeCourante];
    index--;

    context.commit(mutations.choisirEtape.name, Etapes[index]);
    context.commit(mutations.desactiverSuivant.name);
    context.commit(mutations.afficherSuivant.name);

    return context.state.etapeCourante.toString();
  },
  etapeDepart(context) {
    context.commit(mutations.choisirEtape.name, Etapes[0]);
    context.commit(mutations.desactiverSuivant.name);
    context.commit(mutations.afficherSuivant.name);

    return context.state.etapeCourante.toString();
  },
  choisirEtape(context, etape) {
    context.commit(mutations.choisirEtape.name, etape);
    context.commit(mutations.desactiverSuivant.name);
    context.commit(mutations.afficherSuivant.name);

    return context.state.etapeCourante.toString();
  },
  debuterLocation(context) {
    context.commit(mutations.choisirEtape.name, Etapes[1]);
    context.commit(mutations.desactiverSuivant.name);
    context.commit(mutations.afficherSuivant.name);

    return context.state.etapeCourante.toString();
  },
};

export default {
  state,
  actions,
  mutations,
};
